module.exports = __webpack_public_path__ + "img/front_19.2ad01a99.svg";